import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function duplicateValidator(
    targetArray: string[],
    initialValue: string | null = null
): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const targetArrayLower = targetArray.map(x => x.toLowerCase().trim());
        const value = control.value?.trim().toLowerCase();
        const initValueTrimmed = initialValue?.trim().toLowerCase();
        if (
            value == null ||
            value.length === 0 ||
            (initValueTrimmed != null && initValueTrimmed === value)
        ) {
            return null;
        }
        return targetArrayLower.length === 0 || !targetArrayLower.includes(value)
            ? null
            : { duplicate: true };
    };
}
